/**
 * Módulo de mapa - DEPRECADO para variables de runtime.
 * 
 * Las variables mapEngine, googleMapsApiKey y osmUrl ahora se gestionan
 * desde el módulo runtimeConfig. Este módulo se mantiene por compatibilidad
 * pero los getters redirigen a runtimeConfig.
 * 
 * Usar:
 * - this.$store.getters['runtimeConfig/mapEngine']
 * - this.$store.getters['runtimeConfig/googleMapsApiKey']
 * - this.$store.getters['runtimeConfig/osmUrl']
 */
export default ({
  state: {
    // Mantenemos el estado vacío, los getters redirigen a runtimeConfig
    osmAttribution: "Map data &copy; <a href='https://www.openstreetmap.org/'>OpenStreetMap</a> contributors, <a href='https://creativecommons.org/licenses/by-sa/2.0/'>CC-BY-SA</a>" // eslint-disable-line
  },
  getters: {
    // Redirigir a runtimeConfig para mantener compatibilidad con código existente
    mapEngine: (state, getters, rootState, rootGetters) => rootGetters['runtimeConfig/mapEngine'],
    googleMapsApiKey: (state, getters, rootState, rootGetters) => rootGetters['runtimeConfig/googleMapsApiKey'],
    osmUrl: (state, getters, rootState, rootGetters) => rootGetters['runtimeConfig/osmUrl'],
    osmAttribution: state => state.osmAttribution
  }
})
